export default {
  itDetailsTabs: [
    "details",
    "items",
    "participants",
    "documents",
    "finances",
    "customDataTypes",
  ],
  "iti-builder-items-list-cols": [
    "orderNo",
    "startDate",
    "supplierName",
    "serviceName",
    "qty",
    "pax",
    "price",
    "status",
    "actions",
  ],
  supplierDetails: [
    "details",
    "finances",
    "services",
    "rates",
    "extras",
    "contents",
  ],
  itBuilderItemsSortBy: "orderNo",
  itDetailsItemsSortBy: "orderNo",
  destinationsTreeView: false,
  itBuilderView: "table",
  outlinedInputs: true,
  itBuilderOnePageView: true,
  itBuilderShowQuickAdd: false,
  itBuilderVisibleColumns: [
    "status",
    "serviceName",
    "actions",
    "price",
    "rateType",
    "supplierName",
    "serviceType",
    "orderNo",
    "startDate",
    "duration",
    "pax",
    "qty",
  ],
  "itinerary-list": [
    "startDate",
    "reference",
    "agentName",
    "totalPrice",
    "bookingStatus",
    "currencyCode",
    "createdBy",
    "internalRef",
    "balance",
    "adults",
    "children",
    "clientName",
    "actions",
  ],
  supplierOnePageView: false,
  "SUPPLIER-contents-settings": true,
  "supplier-discounts": [
    "description",
    "validFrom",
    "validTo",
    "agentName",
    "bookBeforeDate",
    "advanceDays",
    "minBook",
    "free",
    "percent",
    "agentGrupName",
    "serviceName",
    "actions",
  ],
  "supplier-discounts-showGroupedView": true,
  "supplier-list": [
    "name",
    "code",
    "destination",
    "telephone",
    "email",
    "headOfficeName",
    "actions",
  ],
  ClientList: [
    "name",
    "surname",
    "email",
    "code",
    "telephone",
    "nationality",
    "actions",
  ],
  SalesInovoiceList: [
    "number",
    "amount",
    "currencyCode",
    "itineraryStartDate",
    "paid",
    "internalReference",
    "itineraryStatus",
    "itineraryBrand",
    "itineraryInternalStatus",
    "actions",
  ],
  PaymentList: [
    "payerSurname",
    "amount",
    "currencyCode",
    "exported",
    "department",
    "agentName",
    "lodgementDate",
    "lodgementReference",
    "itineraryReference",
    "itineraryStartDate",
    "actions",
  ],
  PurchaseInovoiceList: [
    "clientSurname",
    "supplierName",
    "itineraryReference",
    "amount",
    "currencyCode",
    "agentName",
    "reference",
    "clientName",
    "itineraryStartDate",
    "piNumber",
    "actions",
  ],
  PurchaseInvoicePaymentList: [
    "clientSurname",
    "supplierName",
    "itineraryReference",
    "amount",
    "currencyCode",
    "agentName",
    "reference",
    "itineraryStartDate",
    "piNumber",
    "headOfficeName",
    "exported",
    "payeeName",
    "actions",
  ],
  itDetailsBoxesSettings: {
    columns: 4,
    visibleItems: [
      "Agent",
      "Reference",
      "Booking Status",
      "Internal Status",
      "Internal Ref",
      "Client",
      "Pax",
      "Created by",
      "Start Date",
      "End Date",
      "Total Price",
      "Balance",
    ],
  },
};



// WEBPACK FOOTER //
// ./src/constants/layout-settings.js